import dailyAttendance from '@/api/human-resource/daily-attendance'
import { baseState, baseMutations } from '@/store/mixins'
import { get, join } from 'lodash'

export const state = {
  ...baseState,
  orgChartStructures: [],
  positions: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_ORG_CHART_STRUCTURE(state, data) {
    state.orgChartStructures = data
  },
  SET_POSITION(state, data) {
    state.positions = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          date_between: join(attributes.dateRange, ',')
        },
        // Pass these as top-level params, NOT inside filter{}
        org_chart_structure_id: get(attributes, 'org_chart_structure_id'),
        position_id: get(attributes, 'position_id'),
        status: get(attributes, 'status')
      },
      attributes
    )
    return dailyAttendance.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  async getOrgChartStructure(context, attributes = {}) {
    let response = await dailyAttendance.orgChartStructure({
      params: attributes
    })
    context.commit('SET_ORG_CHART_STRUCTURE', response.data)
  },

  async getPositions(context, attributes = {}) {
    let response = await dailyAttendance.position({
      params: { ...attributes } // spread to ensure plain object
    })
    context.commit('SET_POSITION', response.data)
  },

  exportExcel(context, data) {
    return dailyAttendance.exportExcel(data)
  },

  generateReport(context, data) {
    return dailyAttendance.generateReport(data)
  }
}
